"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatWeeklyHours = void 0;

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Interpret recurring clock times on their stored dates, preserving historical rules.
var formatWeeklyHours = function formatWeeklyHours(hours) {
  var timeZone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'America/Vancouver';
  var breakSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ', ';
  if (!hours || !hours.open || !hours.close) return 'Closed';
  var zone = _momentTimezone.default.tz.zone(timeZone) ? timeZone : 'America/Vancouver';

  var format = function format(value) {
    return (0, _momentTimezone.default)(value).tz(zone).format('LT');
  };

  if (hours.breakStart && hours.breakEnd) {
    return "".concat(format(hours.open), " - ").concat(format(hours.breakStart)).concat(breakSeparator).concat(format(hours.breakEnd), " - ").concat(format(hours.close));
  }

  return "".concat(format(hours.open), " - ").concat(format(hours.close));
};

exports.formatWeeklyHours = formatWeeklyHours;
